
// src/connects/user-timeline-page.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import lifecycle from '../helpers/lifecycle'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'
import { emitAlertMessage } from '../actions/alert-message'
import find from 'lodash/find'
import ui from '../helpers/ui-state'

export const mapStateToProps = (state, ownProps)=> {
  return {
    isFetching: state.subDiaries.isFetching,
    isFetchFailed: state.subDiaries.isFetchFailed,
    hasMore: state.subDiaries.hasMore,
    diaries: state.subDiaries.items,
    _groups: state.groups.items,
    user: state.user.current,
    users: state.users.items,
    _favoriteUsers: state.favorite.users,
    _blockUsers: state.block.users,
    isCreating: state.chatRooms.isCreating,
    isCreateFailed: state.chatRooms.isCreateFailed,
    created: state.chatRooms.created,
    likeConfig: state.likes.likeConfig,
    rightSidePage: state.rightSidePage.name,
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  const group = ownProps.params.group_id && find(stateProps._groups, (item)=> item.group_id == ownProps.params.group_id) || undefined
  const targetUser = group && group.members && find(group.members, (item)=> item.user_id == ownProps.params.user_id) || stateProps.users && stateProps.users[ownProps.params.user_id]
  const isFavorite = targetUser && find(stateProps._favoriteUsers, (user)=> user.user_id == targetUser.user_id)
  const isBlock = targetUser && find(stateProps._blockUsers, (user)=> user.user_id == targetUser.user_id)

  return {
    isFavorite: !!isFavorite,
    isBlock: !!isBlock,
    group,
    targetUser,
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    fetchDiaries: (props)=> {
      if (props.isFetching || props.isFetchFailed || !props.hasMore) return
      if (props.params.group_id)
        dispatch(actions.fetchSubDiaries(props.params.group_id, props.diaries && props.diaries.length || 0, { user_id: props.params.user_id }))
      else
        dispatch(actions.fetchHomeSubUserDiaries(props.diaries && props.diaries.length || 0, props.params.user_id))
    },

    updateFavoriteUser: (props, favorite)=> {
      dispatch(actions.updateFavoriteUser(props.targetUser.user_id, favorite))
      dispatch(emitAlertMessage({ message: favorite ? 'label:お気に入りユーザに追加しました' : 'label:お気に入りユーザから削除しました', name: props.targetUser && props.targetUser.name }, 'success'))
    },

    updateBlockUser: (user, block)=> {
      dispatch(actions.updateBlockUser(user.user_id, block))
      dispatch(emitAlertMessage({ message: block ? 'label:ユーザをブロックしました' : 'label:ユーザをブロック解除しました', name: user && user.name }, 'success'))
    },

  openChatRoom: (props)=> {
    if(props.targetUser.user_id != props.user.user_id) {
      const chatuser = [props.targetUser.user_id] 
      dispatch(actions.createChatRoom(chatuser))
    }else {
      dispatch(emitAlertMessage({ message: 'label:ご自身のユーザーでチャットを行うことはできません' }, 'error'))
    }
  },

  notIsMember: ()=> dispatch(emitAlertMessage({ message: 'label:対象ユーザーはこのグループに所属していません' }, 'error')),

  openUserSettingsPage: ()=> {
    dispatch(actions.openUserSettingsPage("profile"))
  },

    readDiary: (props, diary)=> {
      const read = diary.user && diary.user.user_id == props.user.user_id || diary.readers && find(diary.readers, (reader)=> reader.user.user_id == props.user.user_id)
      !read && dispatch(actions.markDiaryRead(diary.diary_id))
    },

    willMount: (props)=> {
      if (!props.targetUser)
        dispatch(actions.fetchUserInfo(props.params.user_id))
      dispatch(actions.fetchFavoriteUsers())
      if (props.params.group_id)
        dispatch(actions.fetchSubDiaries(props.params.group_id, 0, { user_id: props.params.user_id }))
      else
        dispatch(actions.fetchHomeSubUserDiaries(0, props.params.user_id))
    },

    willUpdate: (props, nextProps)=> {
      if (props.params.group_id && props.params.group_id != nextProps.params.group_id ||
          props.params.user_id != nextProps.params.user_id) {
          dispatch(actions.fetchUserInfo(nextProps.params.user_id))
        if (nextProps.params.group_id){
          dispatch(actions.fetchSubDiaries(nextProps.params.group_id, 0, { user_id: nextProps.params.user_id }))
        }else{
          dispatch(actions.fetchHomeSubUserDiaries(0, nextProps.params.user_id))
        }
      }
      if (props.isCreating && !nextProps.isCreating && !nextProps.isCreateFailed && nextProps.created) {
        dispatch(actions.openRightSidePage('chat_messages', { chat_room_id: nextProps.created.chat_room_id }))
      }
    },

    willUnmount: ()=> dispatch(actions.clearSubDiaries()),
    postUserReport: (props) => {
      dispatch(actions.postUserReport(props.user.user_id, props.targetUser.user_id))
    }
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({
    state:{
      is_summary: false
  }}),
  lifecycle,
  translate(),
  trackPage('user_timeline'),
)



// WEBPACK FOOTER //
// ./src/connects/user-timeline-page.js